import {
  Filter
} from '../common/filter';
import {
  TYPE_DIMENSIONS,
  isStrictDimention
} from './type-dimensions';
import {
  DEFAULT_STAT_LIMIT,
  CONDITIONS_META,
  REG_EXP_PREF_CASE_UNSENSETIVE,
  REG_EXP_PREF,
} from '../common/config';

export class CurrentFilterService {
  constructor(
    PermissionService,
    FiltersService,
    FilterResource,
    CurrentModelService,
    $rootScope,
    $timeout,
  ) {
    this.$timeout = $timeout;
    this.FilterResource = FilterResource;
    this.FiltersService = FiltersService;
    this.CurrentModelService = CurrentModelService;
    this.defaultDimension = window.defaultDimension ||
      'agent_account@user_name:user_name';
    this.filterBar = new Filter('Bar');
    this.filterBar.setDrilldown(this.defaultDimension);
    this.filter = null;

    this.PermissionService = PermissionService;

    this.timeFrom = new Date();
    this.timeTo = new Date(this.timeFrom.valueOf());
    this.timeFrom.setHours(0, 0, 0, 0);
    this.timeTo.setHours(23, 59, 59, 999);
    this.$rootScope = $rootScope;
    this.panel = 'constructor';
    $timeout(() => {
      this.updatePanel();
    }, 100);

    this.visibleDimensions = [];
  }

  createNewFilter(name, type) {
    let filterName;
    if (!name) {
      if (type && this.PermissionService.types[type])
        filterName = `${this.PermissionService.types[type].name} 1`;
      else if (type) filterName = `${type} 1`;
      else null;
    } else filterName = name;
    const filter = new Filter(filterName);
    this.setFilterName(filter);
    if (type) filter.content_type = type;
    return filter;
  }

  setFilterName(filter) {
    const setFilterName = () => {
      const parts = filter.name.split(' ');
      if (parts.length > 1) {
        let idx = '1';
        if (parseInt(parts[parts.length - 1], 10)) {
          idx = parseInt(parts[parts.length - 1], 10) + 1;
          parts.pop();
        }
        filter.name = parts.join(' ') + ' ' + idx;
      } else {
        filter.name = parts[0] + ' 1';
      }
    };
    while (this.FiltersService.find(f => (f.name === filter.name) && (f.id !== filter.id))) {
      setFilterName();
    }
    while (this.filter && this.filter.children && this.filter.children
      .find(f => (f.name === filter.name) && (f.id !== filter.id || !f.id))) {
      setFilterName();
    }
  }

  newFilter(name, type) {
    this.filter = this.createNewFilter(name, type);
    if (type) {
      this.filter.content_type = type;
      if (this.filter.isDashboard || this.filter.isCard) this.filter.mode = type;
    }
  }

  rebuildVisibleDimensions() {
    let dims;
    if (this.filter && this.filter.filters && this.filter.filters.length > 0) {
      const selected = this.filter.filters.filter(f =>
          f['dimension'] === 'agent_eventtype@default:agent_eventtype' &&
          !f.predicates.filter(p => p === '!').length)
        .map(f => f['value']);
      dims = selected.map(key_selected => TYPE_DIMENSIONS[key_selected])
        .reduce((prev, curr) => {
          return prev.concat(curr ? curr.filter(dim => prev.indexOf(dim) === -1) : []);
        }, []);
    }
    if (dims && dims.length) {
      this.visibleDimensions = this.CurrentModelService.model.dimensions
        .filter(dim => dims.indexOf(dim['name']) !== -1);
    } else {
      this.visibleDimensions = this.CurrentModelService.model ?
        this.CurrentModelService.model.dimensions : [];
    }
  }

  get aggregateBarOrderName() {
    const dimension = this.CurrentModelService.model
      .getDimensionParts(this.filterBar.drilldown[0]);
    return `${dimension.dimension.name}.${dimension.level.label_attribute}`;
  }

  setOrderBar(dimension) {
    switch (this.filterBar.aggrOrder) {
      case 'nameAsc':
        this.filterBar.orderDir = 'asc';
        if (Filter.isTimeDimension(dimension)) {
          this.filterBar.order = Filter.orderForTimeDimension(dimension);
        } else this.filterBar.order = this.aggregateBarOrderName;
        break;
      case 'nameDesc':
        this.filterBar.orderDir = 'desc';
        if (Filter.isTimeDimension(dimension)) {
          this.filterBar.order = Filter.orderForTimeDimension(dimension);
        } else this.filterBar.order = this.aggregateBarOrderName;
        break;
      case 'statAsc':
        this.filterBar.order = 'record_count';
        this.filterBar.orderDir = 'asc';
        break;
      case 'statDesc':
        this.filterBar.order = 'record_count';
        this.filterBar.orderDir = 'desc';
        break;
      default:
        if (Filter.isTimeDimension(dimension)) {
          this.filterBar.orderDir = 'asc';
          this.filterBar.order = Filter.orderForTimeDimension(dimension);
        } else {
          this.filterBar.orderDir = 'desc';
          this.filterBar.order = 'record_count';
        }
    }


    this.filterBar.changed();
  }

  selectBarDim(dim) {
    if (this.filter) this.filterBar.copyFrom(this.filter, true);
    this.filterBar.setDrilldown(dim.toString());
    this.setOrderBar(dim.toString());
    this.filterBar.setKeyword('');
    this.filterBar.page = 0;
    this.filterBar.lookup = null;
  }

  getReportQuery(filterBase) {
    const filter = new Filter('Report');
    const srcFilter = filterBase || this.filter;
    filter.copyFrom(srcFilter);
    filter.filters = srcFilter.filters.slice(0);
    filter.timeFrom = this.timeFrom;
    filter.timeTo = this.timeTo;
    filter.timePeriod = this.timePeriod;
    const obj = filter.buildQueryParams();

    if (this.filter.isCardOrDashboard) {
      obj.inDashboard = 1;
    }

    if (filter.isReports) {
      delete obj.order;
      delete obj.dir;
      if (filter.repOrderDirs) obj.repOrderDirs = filter.repOrderDirs;
      if (filter.repOrders) obj.repOrders = filter.repOrders;
    }
    obj['limit'] = srcFilter.customLimit ? srcFilter.customLimit : DEFAULT_STAT_LIMIT;

    const serialize = function(obj) {
      const str = [];
      for (const p in obj) {
        if (obj.hasOwnProperty(p)) {
          let v = obj[p];
          if (v instanceof Date) {
            v = v.toISOString();
          }
          if (v instanceof Array) {
            for (const idx in v) {
              str.push(encodeURIComponent(p) + '=' + encodeURIComponent(v[idx]));
            }
          } else str.push(encodeURIComponent(p) + '=' + encodeURIComponent(v));
        }
      }
      return str.join('&');
    };

    return serialize(obj);
  }

  getReportUrl(filter) {
    if (!filter || !filter.url) {
      return null;
    }
    const base = filter.url;
    if (base.indexOf('?') < 0) {
      return `${base}?${this.getReportQuery(filter)}`;
    } else {
      return `${base}&${this.getReportQuery(filter)}`;
    }
  }

  generateReport(url) {
    this.filter.setMode('reports');
    delete this.filter.content_type;
    this.filter.url = url;
  }

  openFrame(url) {
    this.frameUrl = url;
  }

  reset() {
    this.frameUrl = null;
  }

  buildCardFilter() {
    const criterion = this.filter.filters[0];
    if (!criterion || this.filter.filters.filter(f => f.dimension === criterion.dimension).length !== 1) {
      console.error('card filter should have at least one criterion');
      this.filter.children = [];
      return;
    }
    this.FiltersService.getCardFilter(criterion.dimension).then(cardFilter => {
      if (cardFilter) {
        this.filter.cardFilter = cardFilter;
        this.filter.children = cardFilter.children
          .map(f => Object.assign(new Filter(), f, {
            _changed: true,
            filters: this.filter.filters.concat(f.filters)
          }));
        this.filter.name = this.filter.cardFilter.name;
        this.setFilterName(this.filter);
      } else {
        this.filter.children = [];
      }
      const flt = this.FiltersService.findById(this.filter.id);
      this.filter.saved = flt ? !!this.filter.id && angular.equals(flt.filters, this.filter.filters) : !!this.filter.id;
      this.$timeout(() => {
        this.$rootScope.$apply();
      }, 10);
    });
  }

  getTimeFrom() {
    return Filter.dateToUrl(this.timeFrom);
  }

  getTimeTo() {
    return Filter.dateToUrl(this.timeTo);
  }

  updatePanel() {
    this.panel = this.PermissionService.filterConstructor === false ? 'catalog' : 'constructor';
    this.filterBar.skipStat = !this.PermissionService.aggregate_show_stat;
  }


  getFilterError(filter) {
    const result = {
      fields: {},
      text: '',
      error: false,
      source: 'filter'
    };

    const contunueCheckFilter = () => {
      if (filter.content_type === 'policy' || filter.content_type === 'deletepolicy' || filter.isAnalyticPolitic) {
        if (filter.filters && !filter.filters.length && !filter.hasQuery) {
          if (filter.content_type === 'deletepolicy') {
            result.text = gettext('Пожалуйста, укажите данные для удаления создав фильтр в конструкторе.');
            result.error = true;
            result.source = 'policy-limit';
            return Promise.resolve(result);
          }
          result.text = gettext('Пожалуйста, ограничьте обьем обрабатываемых данных создав фильтр в конструкторе.');
          result.error = true;
          result.source = 'policy-limit';
        }
      }
      if (result.error) return Promise.resolve(result);
      return this.getQueryError(filter);
    };

    const MAX_SAFE_INTEGER = 9007199254740991;

    if (filter.send_threshold) {
      if (filter.threshold_period < 0 || filter.threshold_period >= MAX_SAFE_INTEGER) {
        result.fields.threshold_period = gettext('Неверное значение "Период порога срабатывания"!');
        result.error = true;
        return Promise.resolve(result);
      }
      if (filter.threshold < 0 || filter.threshold >= MAX_SAFE_INTEGER) {
        result.fields.threshold = gettext('Неверное значение "Достижение порога срабатывания"!');
        result.error = true;
        return Promise.resolve(result);
      }
    }

    if (filter.content_type === 'corpusprocessfilter') {
      if (!filter.corpus_data) {

        result.text = gettext('Заполните словарь');
        result.error = true;
        return Promise.resolve(result);
      } else {

        const regs = filter.corpus_data ? filter.corpus_data.split('\n')
          .filter(w => w[0] === REG_EXP_PREF_CASE_UNSENSETIVE || w[0] === REG_EXP_PREF).map(w => w.substr(1)) : [];
        return this.FilterResource.checkRegExps(regs).then(err => {
          if (err) {
            result.text = err;
            result.error = true;
            return Promise.resolve(result);
          } else {
            return contunueCheckFilter();
          }
        });
      }
    }
    return contunueCheckFilter();
  }

  getQueryError(filter) {
    const result = (errText, resolve) => {
      return resolve({
        fields: {},
        text: errText,
        error: !!errText,
        source: 'filter'
      });
    };
    const _isStrictDimention = isStrictDimention;
    const allowSameValueLabel = (dim, hier) => {
      const allow = {
        agent_time: {
          hour: true,
          time_zone: true,
          y: true,
        }
      };
      return allow[dim] && allow[dim][hier];
    };

    const getRulePromise = rule => {
      return new Promise(resolve => {
        if (rule.group) return rule.group.operator === 'AND' || rule.group.operator === 'OR' ?
          result('', resolve) :
          result(gettext('неправильный оператор ("operator")'), resolve);
        if (!rule.condition) return result(gettext('отсутствует условие ("condition")'), resolve);
        if (!CONDITIONS_META[rule.condition]) return result(gettext('неправильное условие ("condition")'), resolve);
        if (!rule.dimension) return result(gettext('отсутствует "dimension"'), resolve);
        if (!rule.hierarchy) return result(gettext('отсутствует "hierarchy"'), resolve);

        if (rule.dimension != 'local_time' && rule.dimension != 'text_data') {
          const dimension = this.CurrentModelService.model._dimensions.find(d => d.name == rule.dimension);
          if (!dimension) return result(gettext('неверное dimension') + `- "${rule.dimension}"`, resolve);
          if (!rule.hierarchy) return result(gettext('отсутствует "hierarchy"'), resolve);
          if (!dimension.hierarchies.find(h => h.name == rule.hierarchy))
            return result(gettext('неверное hierarchy') + `- "${rule.hierarchy}"`, resolve);
        }

        if (_isStrictDimention(rule.dimension, rule.hierarchy)) {
          if (!rule.label) return result(gettext('отсутствует значение'), resolve);
          if (rule.value === rule.label && !allowSameValueLabel(rule.dimension, rule.hierarchy))
            return result(gettext('неверное значение') + ` "${rule.label}"`, resolve);
        }

        if (rule.condition === 'D' || rule.condition === '!D' || rule.dimension === 'local_time') {
          if (typeof rule.value !== 'number') {
            if (!rule.value) return result(gettext('отсутствует значение'), resolve);
            return result(gettext('неверное значение'), resolve);
          }
        } else if (typeof rule.value === 'number') {
          return result(gettext('неверное значение'), resolve);
        }
        if (rule.condition === 'R') {
          return this.FilterResource.checkRegExp(rule.value)
            .then(errText => {
              if (errText) return result(errText, resolve);
              return result('', resolve);
            });
        } else return result('', resolve);
      });
    };

    return new Promise(resolve => {
      if (!filter.hasQuery) return result('', resolve);
      if (filter.query.operator !== 'AND' && filter.query.operator !== 'OR')
        return result(gettext('неправильный оператор ("operator")'), resolve);


      // let errMessage = null;

      const iter = rules => {
        if (!rules.length) return result('', resolve);
        const checkRule = i => {
          const rule = rules[i];
          return getRulePromise(rule)
            .then(errMessage => {
              if (errMessage.error) result(errMessage.text, resolve);
              if (rule.group && rule.group.rules && rule.group.rules.length) return iter(rule.group.rules);
              if (i >= rules.length - 1) return result('', resolve);
              i += 1;
              return checkRule(i);
            });
        };
        return checkRule(0);
      };
      return iter(filter.query.rules);
    });
  }
}



// WEBPACK FOOTER //
// ./src/core/current-filter.service.js